import { registerPlugin, Capacitor } from '@capacitor/core';
import { getDeviceId } from '@/lib/api';

const Plugin = registerPlugin('NotificationGuard');

export const guardAvailable = () => Capacitor.getPlatform() === 'android';

export async function guardState() {
  if (!guardAvailable()) return { available: false };
  return Plugin.getState();
}

// Push the current identity into the native service so it can call the backend on its own.
export async function guardSync(extra = {}) {
  if (!guardAvailable()) return { available: false };
  let waiver = null;
  try { waiver = JSON.parse(localStorage.getItem('unmanip_waiver_v1') || 'null')?.version || null; } catch {}
  return Plugin.configure({
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    deviceId: getDeviceId(),
    token: localStorage.getItem('unmanip_token') || '',
    waiver: waiver || '',
    ...extra,
  });
}

export const guardOpenSettings = () => Plugin.openListenerSettings();
export const guardRequestPost = () => Plugin.requestPostPermission();
export const guardRequestOverlay = () => Plugin.requestOverlayPermission();
export const guardPreviewHud = (opts = {}) => Plugin.previewHud(opts);
export const guardHideHud = () => Plugin.hideHud();
